import React from 'react'

const ArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 13.0104L3.45929 6.46961L2.39863 7.53027L10 15.1317L17.6014 7.53027L16.5408 6.46961L10 13.0104Z" fill="#6B7073"/>
  </svg>
)

export default ArrowDown